import './landing-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class LandingScreen
 * @implements {ng.IComponentOptions}
 */
export class LandingScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = LandingScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./landing-screen.html').toString()

  /**
     * Object containing pairs Directive Bindings for Component
     *
     * @type {Object}
     */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * LandingScreen - Controller
 *
 * @export
 * @class LandingScreenController
 */
export class LandingScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', 'AudioManager', 'TrackingManager', '$rootScope']
  public options: any
  public isLast: boolean
  public isFirst: boolean
  public shareScreenOptions:any
  public navReady

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public AudioManager: any, public TrackingManager: any, public $rootScope: any) {
    this.$log = $log.getInstance('LandingScreen', false);
    this.$log.debug('constructor')

    this.shareScreenOptions = {
      "title": "Share Screen",
      "enterNextTransition": "pt-page-moveFromRight",
      "exitNextTransition": "pt-page-moveToLeft",
      "enterPreviousTransition": "pt-page-moveFromLeft",
      "exitPreviousTransition": "pt-page-moveToRight",
      "active": false,
      "contents": "share-screen",
      "nextCover": false,
      "previousCover": false,
      "navReady": false
    }
  }

  public onNext() {
    this.AppServices.ScreenManager.performNavigation('next', this.options);

  }

  public onPrevious() {
    this.AppServices.ScreenManager.performNavigation('previous', this.options)
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
    // this.AngularServices.$animate.removeClass(angular.element(document.querySelector('.landing-screen__start')), 'flipOutX');
    // this.AngularServices.$animate.addClass(angular.element(document.querySelector('.landing-screen__start')), 'flipInX');
    this.$rootScope.$broadcast('creatorScreenIsActive', { disableNav: true });
  }
  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
  }


  public onExitStart() {
    this.$log.debug("onExitStart")
    // this.AngularServices.$animate.removeClass(angular.element(document.querySelector('.landing-screen__start')), 'flipInX');
    // this.AngularServices.$animate.addClass(angular.element(document.querySelector('.landing-screen__start')), 'flipOutX');
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
  }

  public onClick(ev) {
    //this.AppServices.AudioManager.playBackgroundTrack(this.AppServices.AudioManager.settings.initialBackgroundTrackKey)
    this.AudioManager.playFx('playbutton');
    let screenIndex = this.AppServices.ProgressManager.getScreenIndex()
    //need to boot the music
    this.AudioManager.playBackgroundTrack(this.AudioManager.settings.initialBackgroundTrackKey)
    if (this.AppServices.ProgressManager.valueExists(screenIndex)) {
      this.AppServices.ProgressManager.jumpToSavedScreen();
    } else {
      this.onNext();
    }
    /* track the start button click with a temporary timestamp */
    this.TrackingManager.trackStart();
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;


    this.AngularServices.$timeout(() => {
      this.AppServices.ProgressManager.applySavedProgress()
    }, 500)

  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges')
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/landing-screen/landing-screen.ts
 **/